var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6C10 4.89543 10.8954 4 12 4H27C28.1046 4 29 4.89543 29 6V13H10V6ZM6 13V6C6 2.68629 8.68629 0 12 0H27C30.3137 0 33 2.68629 33 6V13H34.0039C36.213 13 38.0039 14.7909 38.0039 17V34C38.0039 36.2091 36.213 38 34.0039 38H4.00391C1.79477 38 0.00390625 36.2091 0.00390625 34V25H0.560934C0.77981 25 0.998028 25.024 1.21169 25.0714L17.9164 28.7834C18.6307 28.9421 19.3712 28.9421 20.0856 28.7834L36.7893 25.0714C37.0029 25.024 37.2212 25 37.4401 25H38.001V23H37.4401C37.0753 23 36.7115 23.0399 36.3554 23.1191L19.6517 26.831C19.2231 26.9262 18.7788 26.9262 18.3502 26.831L1.64553 23.1191C1.28942 23.0399 0.925727 23 0.560934 23H0.00390625V17C0.00390625 14.7909 1.79477 13 4.00391 13H6ZM0.00390625 23H0V25H0.00390625V23Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/Bookings.c0beac8f94b9d848c61a4d78b9837699.svg";
export { ForwardRef as ReactComponent };